module.exports = __webpack_public_path__ + "img/circle-info.14925542.svg";